import React, { useState } from 'react';
import { toggleAlert } from '../store/resuders/app.reducer';
import { useAppDispatch } from '../store/hooks';

interface PaginationGoToPageTextboxProps {
    totalPages: number;
    currentPage: number;
    hadlePageChange: (page: number) => void;
}

const PaginationGoToPageTextbox: React.FC<PaginationGoToPageTextboxProps> = ({
    totalPages,
    currentPage,
    hadlePageChange,
}) => {
    const [inputPage, setInputPage] = useState<string>('');
    const dispatch = useAppDispatch();

    const handlePageChange = () => {
        const pageNumber = parseInt(inputPage, 10); // Convert the input value to a number
        if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages) {
            hadlePageChange(pageNumber); // Call the parent callback with the valid page number
        } else {
            dispatch(toggleAlert(`Please enter a valid page number between 1 and ${totalPages}.`));
        }
        setInputPage(''); // Clear the input field
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem'}}>
            <div style={{ position: 'relative', width: '100px' }}>
                <input
                    type="text"
                    value={inputPage} // Bind to the input state
                    onChange={(e) => setInputPage(e.target.value)} // Handle input changes
                    placeholder="Go to Page"
                    title="Go to Page" 
                    style={{
                        padding: '0.5rem',
                        width: '100%',
                        boxSizing: 'border-box',
                        paddingRight: '2.5rem',
                        fontSize: '9px'
                    }}
                />
                <button
                   onClick={handlePageChange}
                   className='go_button'
                >
                    Go
                </button>
            </div>
        </div>
    );
};

export default PaginationGoToPageTextbox;

function dispatch(arg0: any) {
    throw new Error('Function not implemented.');
}
